import { ModelBase } from "@shoothill/core";
import { action, observable } from "mobx";

export class DilapidationTypesLookupModel extends ModelBase<DilapidationTypesLookupModel, any> {
    // #region Constructors and Disposers
    // #endregion Constructors and Disposers

    // #region Defaults and Constants

    public static readonly DEFAULT_ID = "";
    public static readonly DEFAULT_DISPLAYNAME = "";

    // #endregion Defaults and Constants

    // #region Observables

    @observable
    public id: string = DilapidationTypesLookupModel.DEFAULT_ID;

    @observable
    public displayName: string = DilapidationTypesLookupModel.DEFAULT_DISPLAYNAME;

    // #endregion Observables

    // #region Actions

    @action
    public reset(): void {
        this.id = DilapidationTypesLookupModel.DEFAULT_ID;
        this.displayName = DilapidationTypesLookupModel.DEFAULT_DISPLAYNAME;
    }

    @action
    public fromDto(dto: DilapidationTypeDTO): void {
        this.id = dto.id;
        this.displayName = dto.displayName;
    }

    public toDto() {
        throw new Error("Method not implemented.");
    }

    // #endregion Actions

    // #region Helpers

    public static fromDtos(dtos: DilapidationTypeDTO[]): DilapidationTypesLookupModel[] {
        const types: DilapidationTypesLookupModel[] = [];

        for (const dto of dtos) {
            const model = new DilapidationTypesLookupModel();

            model.fromDto(dto);
            types.push(model);
        }

        return types;
    }

    // #endregion Helpers
}

export interface DilapidationTypeDTO {
    id: string;
    displayName: string;
}
